import { render, staticRenderFns } from "./customsprocedure.vue?vue&type=template&id=04c8858c&"
import script from "./customsprocedure.vue?vue&type=script&lang=js&"
export * from "./customsprocedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports